export default __webpack_public_path__ + "static/media/radar_sensor_icon.81da1e20.png";